<template>
  <el-container class="layouts-box">
    <div style="height: 100%;">
      <aside-menu></aside-menu>
    </div>
    <el-container>
      <el-header style="text-align: right; font-size: 12px" height="50px">
        <el-dropdown @command="e => handlerTableDropDown(e)">
          <i class="el-icon-setting" style="margin-right: 15px"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="back">退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span>{{user.nickname}}</span>
      </el-header>

      <el-main class="layouts-main">
        <breadcrumb v-if="!noBreadCrumb"></breadcrumb>
        <div class="layouts-main-child">
          <router-view/>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import AsideMenu from './AsideMenu'
  import Breadcrumb from './Breadcrumb'
  import { mapState } from 'vuex'
  import cookies from '../libs/util.cookies'
  export default {
    name: 'Layout',
    components: {
      AsideMenu,
      Breadcrumb
    },

    computed:{
      ...mapState('common/promise', ['routeName', 'noBreadCrumb']),
      ...mapState('userStore/user', ['user'])
    },
    data() {
      return {
      }
    },
    created() {
      if (localStorage.getItem('user')) {
        console.log(localStorage.getItem('user'))
        this.$store.commit('userStore/user/setUser', JSON.parse(localStorage.getItem('user')))
      }
    },
    methods: {
      handlerTableDropDown(e) {
        if (e == 'back') {
          cookies.remove('token')
          window.location = window.location.href.split('#')[0] + '#/login'
          localStorage.removeItem('user')
        }
      }
    }

  };
</script>

<style lang="scss">
  .layouts-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .el-header {
      background-color: #FFFFFF;
      color: #333;
      line-height: 50px;
      height: 50px;
    }

    .el-aside {
      color: #333;
    }
    .layouts-main {
      background-color: #efefef;
      position: absolute;
      left: 200px;
      right: 0;
      top: 50px;
      bottom: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      .layouts-main-child {
        height: 100%;
        flex: 1;
        background-color: #efefef;
        position: relative;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/layouts.vue